export default "__VITE_ASSET__CD_Ryhe7__"